<form [formGroup]="form">
    <mat-accordion class="w-100">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <b>Unipol / UnipolSai</b>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="row">
                <div class="col-12">
                    <h4>Credenziali API</h4>
                </div>
            </div>

            <p>
                <mat-form-field class="form-fields-wrapper">
                    <mat-label>Client ID</mat-label>
                    <input matInput placeholder="Client ID" formControlName="client_id">
                    <mat-icon matSuffix>vpn_key</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-fields-wrapper">
                    <mat-label>Client Secret</mat-label>
                    <input matInput placeholder="Client Secret" formControlName="client_secret" type="password">
                    <mat-icon matSuffix>lock</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-fields-wrapper">
                    <mat-label>Partita IVA Studio</mat-label>
                    <input matInput placeholder="Partita IVA" formControlName="partita_iva">
                    <mat-icon matSuffix>business</mat-icon>
                </mat-form-field>

                <mat-form-field class="form-fields-wrapper">
                    <mat-label>Ambiente</mat-label>
                    <mat-select formControlName="environment">
                        <mat-option value="test">Test (Collaudo)</mat-option>
                        <mat-option value="produzione">Produzione</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="form-fields-wrapper">
                    <mat-label>Compagnia predefinita</mat-label>
                    <compagnia-picker formControlName="compagnia"></compagnia-picker>
                </mat-form-field>

                <mat-form-field class="form-fields-wrapper">
                    <mat-label>Stato incarico predefinito</mat-label>
                    <stato-incarico-picker formControlName="statoDefault"></stato-incarico-picker>
                </mat-form-field>

            </p>

            <div class="row mt-3">
                <div class="col-12">
                    <h4>Certificati SSL</h4>
                    <p class="text-muted">
                        Carica i file del certificato (.crt) e della chiave privata (.key) forniti da Unipol.
                    </p>
                </div>
            </div>

            <div class="row" *ngIf="certificateUploaded">
                <div class="col-12">
                    <div class="alert alert-success d-flex align-items-center">
                        <mat-icon class="mr-2">check_circle</mat-icon>
                        <span>Certificati caricati</span>
                        <button mat-button color="warn" class="ml-auto" (click)="deleteCertificates()">
                            <mat-icon>delete</mat-icon> Elimina
                        </button>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="!certificateUploaded">
                <div class="col-12">
                    <div class="alert alert-warning d-flex align-items-center">
                        <mat-icon class="mr-2">warning</mat-icon>
                        <span>Certificati non caricati</span>
                    </div>
                </div>
            </div>

            <div class="row mb-3" *ngIf="!certificateUploaded">
                <div class="col-md-6">
                    <label class="d-block mb-1">Certificato (.crt)</label>
                    <input type="file" accept=".crt,.pem,.cert" (change)="onCertFileSelected($event)">
                    <small class="text-muted d-block" *ngIf="certFile">{{ certFile.name }}</small>
                </div>
                <div class="col-md-6">
                    <label class="d-block mb-1">Chiave privata (.key)</label>
                    <input type="file" accept=".key,.pem" (change)="onKeyFileSelected($event)">
                    <small class="text-muted d-block" *ngIf="keyFile">{{ keyFile.name }}</small>
                </div>
            </div>

            <div class="row mb-3" *ngIf="!certificateUploaded && (certFile || keyFile)">
                <div class="col-12">
                    <button mat-raised-button color="accent" (click)="uploadCertificates()" [disabled]="uploading || !certFile || !keyFile">
                        <mat-icon *ngIf="!uploading">cloud_upload</mat-icon>
                        <mat-spinner *ngIf="uploading" diameter="20" class="d-inline-block"></mat-spinner>
                        Carica Certificati
                    </button>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <div class="mat-form-field margin-bottom">
                        <mat-slide-toggle formControlName="enabled" color="primary">Abilitato</mat-slide-toggle>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12">
                    <button mat-raised-button color="primary" class="mb-2" (click)="Salva()">
                        Salva
                    </button>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</form>
